import React, { useState } from 'react'
import { FullWidthVideoHero } from '../components/FullWidthVideoHero'
import { VideoModal } from '../components/VideoModal'
import { isNullOrWhiteSpace } from '../utilities/string'

export interface VideoCampaignHeroProps {
  buttonLabel
  previewImage
  previewVideoUrl
  subtitle
  theme
  title
  videoUrl
}

export const VideoCampaignHero = ({
  buttonLabel,
  previewImage,
  previewVideoUrl,
  subtitle,
  theme,
  title,
  videoUrl,
}: VideoCampaignHeroProps) => {
  const [playingVideoUrl, setPlayingVideoUrl] = useState('')

  const playVideo = (videoUrl: string) => {
    setPlayingVideoUrl(videoUrl)
  }

  return (
    <>
      <FullWidthVideoHero
        buttonLabel={buttonLabel ?? ''}
        playVideoCallback={playVideo}
        previewImage={previewImage}
        previewVideoUrl={previewVideoUrl}
        subtitle={subtitle ?? ''}
        theme={theme ?? ''}
        title={title ?? ''}
        videoUrl={videoUrl}
      />

      <VideoModal
        onClose={() => setPlayingVideoUrl('')}
        open={!isNullOrWhiteSpace(playingVideoUrl)}
        videoUrl={playingVideoUrl}
      />
    </>
  )
}
